export enum Flags {
    IS_URGENT = 'isUrgent',
    IS_STANDARD = 'isStandard',
    IS_REOPENED = 'isReopened',
    IS_ON_HOLD = 'isOnHold',
    IS_QUALITY = 'isQuality'
}
